import { render, staticRenderFns } from "./PotModal.vue?vue&type=template&id=ca80fd72&scoped=true&"
import script from "./PotModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./PotModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PotModal.vue?vue&type=style&index=0&id=ca80fd72&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca80fd72",
  null
  
)

export default component.exports